import { IColor } from '../types/color';

export const color: IColor = {
  /* Strong Red */
  primary: '#C8102E',
  secondary: '#572D2D',
  /* Dark Desaturated Red */
  tertiary: '#432726',
  black: '#000000',
  brightWhite: '#FFFFFF',
  white: '#FFFFFF',
  /* Very Light Gray */
  buttonsDisabledBackground: '#ececec',
  /* Very Dark Gray */
  buttonsDisabledLabel: '#6e6e6e',
  /* Dark Red */
  buttonsPrimaryHover: '#880a1e',
  /* 15% primary */
  buttonsSecondaryHover: '#f4cfd5',
  /* 25% primary */
  buttonsFocused: '#eba9b4',
  /* Dark Desaturated Red */
  buttonsPrimaryActive: '#432726',
  /* Strong Red */
  buttonsSecondaryActive: '#c8102e',
  inputsFocused: '#C90325',
  /* Dark Moderate Green */
  statusValidated: '#5E8035',
  statusError: '#C41230',
  statusPrice: '#C90325',
  /* Bright Orange */
  statusSuccess: '#E68835',
  /* Darkest to Lightest */
  100: '#323231',
  200: '#6E6E6E',
  300: '#76756D',
  400: '#767676',
  /* Dark Grayish Red */
  500: '#8A6C6C',
  600: '#DCDCDC',
  700: '#ECECEC',
  800: '#F4EFE9',
  900: '#F5F1EF',
};
